import React, { useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Import de la vidéo MP4 (placée dans src/assets)
import backSlide6Mp4 from '../assets/BackSlide6.mp4';

// Optionnel : une image pour le poster avant chargement
import backSlide6Poster from '../assets/BackSlide6.jpg';

gsap.registerPlugin(ScrollTrigger);

// Structure principale
const Page = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

// Vidéo en fond
const VideoBg = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  z-index: 0;
  pointer-events: none;
  will-change: transform;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  padding: 0 4rem;

  @media (max-width: 900px) {
    padding: 0 2rem;
  }
`;

const Title = styled.p`
  font-size: 8rem;
  font-family: 'MongoGrotesqueLight';
  margin: 0;
  color: #fff;

  @media (max-width: 900px) {
    display: none;
  }
`;

const TitleMob = styled.p`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    font-size: 5rem;
    font-family: 'MongoGrotesqueLight';
    margin: 0;
    color: #fff;
  }

  @media (max-width: 410px) {
    font-size: 4rem;
  }
`;

const SubtitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  margin: 0;
  color: white;
  width: 60%;

  @media (max-width: 900px) {
    width: 95%;
  }
`;

const Button = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  color: #000;
  text-decoration: none;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;

  @media (max-width: 900px) {
    margin-top: 10%;
  }
`;

const BackgroundPage: React.FC = () => {
  const pageRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
    {/*
  useLayoutEffect(() => {
    if (!pageRef.current || !videoRef.current) return;

    const mm = gsap.matchMedia();

    mm.add('(min-width: 900px)', () => {
      const height = pageRef.current!.clientHeight;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: pageRef.current,
          start: 'top top',
          end: `+=${height}`,
          scrub: true,
          pin: true,
          pinSpacing: true,
          // markers: true, // utile pour debug
        },
      });

      // Effet parallax sur la vidéo
      tl.fromTo(
        videoRef.current,
        { yPercent: 0 },
        { yPercent: 20, ease: 'none' } // ajuste la valeur selon ton rendu
      );

      return () => {
        tl.scrollTrigger?.kill();
        tl.kill();
      };
    });

    return () => {
      mm.revert();
    };
  }, []); */}

  return (
    <Page ref={pageRef}>
      <VideoBg
        ref={videoRef}
        src={backSlide6Mp4}
        poster={backSlide6Poster}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
      <Overlay />
      <Content>
        <Title>
          PRÊT À ORGANISER TON ÉVÈNEMENT<br />AVEC PARTOUCHE ?
        </Title>
        <TitleMob>
          PRÊT À ORGANISER <br />TON ÉVÈNEMENT <br />AVEC PARTOUCHE ?
        </TitleMob>
        <SubtitleRow>
          <Subtitle>
            Chez Partouche Multiverse, l’événementiel est un levier d’émotion, de lien et
            d’innovation. Du yacht du Joker Odyssey à Cannes à l’organisation de salons Web3
            et d’événements dans nos casinos, salles de spectacles, lieux exclusifs ou plages
            privatisées, chaque projet est pensé comme une immersion totale, où le réel et
            le digital se rencontrent.
          </Subtitle>
          <Button>ORGANISER UN ÉVÈNEMENT</Button>
        </SubtitleRow>
      </Content>
    </Page>
  );
};

export default BackgroundPage;
